import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';
import { filteringSchemaFrom, pagingSchema } from '../modifier';
import {
  coachPaymentDepositInfoStatusSchema,
  coachPaymentKind,
  coachPaymentNoteKind,
  coachPaymentStatusKind,
} from './coach-payment-report';

export const payCycleSchema = z.object({
  id: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  paymentDate: z.string(),
});

export const payCycleLikeSchema = z.object({
  startPlainDate: z.instanceof(Temporal.PlainDate),
  endPlainDate: z.instanceof(Temporal.PlainDate),
  paymentPlainDate: z.instanceof(Temporal.PlainDate),
  depositPostedDate: z.string().optional(),
});

export type PayCycleLike = z.infer<typeof payCycleLikeSchema>;

export const getPayCycleFilterSchema = z.object({
  payCycleInterval: z.string().optional(),
  query: z.string().optional().catch(''),
  type: z.array(z.lazy(() => coachPaymentKind)).optional(),
  payDate: z.string().optional(),
  coachPaymentIds: z.array(z.string()).optional(),
  paymentSentStatus: z.array(z.lazy(() => coachPaymentStatusKind)).optional(),
  depositInfoStatus: z.array(z.lazy(() => coachPaymentDepositInfoStatusSchema)).optional(),
  notes: z.array(z.lazy(() => coachPaymentNoteKind)).optional(),
});
export type GetPayCycleFilter = z.infer<typeof getPayCycleFilterSchema>;

export const getPayCycleModifierSchema = pagingSchema.merge(filteringSchemaFrom(getPayCycleFilterSchema));
export type GetPayCycleModifierSchema = z.infer<typeof getPayCycleModifierSchema>;

export const getPayCyclesSchema = z.object({
  startPlainDate: z.instanceof(Temporal.PlainDate),
  endPlainDate: z.instanceof(Temporal.PlainDate),
  paymentPlainDate: z.instanceof(Temporal.PlainDate),
});

export type GetPayCyclesResult = z.infer<typeof getPayCyclesSchema>;
